import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStore } from '@store';
import { observer } from 'mobx-react-lite';
import '@style/counter.css';
import { Page, CustomerInfo, Loading } from '@components';
import IsCash from './components/IsCash';
import IsStock from './components/IsStock';
import ApplyModal from './components/ApplyModal';
import StockApplyModal from './components/StockApplyModal';
import Complete from '@components/Complete/Complete';
import Notice from '@components/Layout/Notice';
import TransFlagModal from '@components/Layout/TransFlagModal';
const PayOff = () => {
    const [isCash, setIsCash] = useState(true);
    const {
        PayOffStore: {
            getCashQry,
            payOffMoney,
            stockList,
            repayMentPartInterest,
            payOffComplete,
            updateData,
            getPayoffBusinessTime,
            transType,
            transInfoVisible,
            repaymentSwitchVisible,
            isLoading,
            loadingFailed,
            msg,
            transFlagModalVisible,
            closeTransFlagModal,
            TransMsg,
            repaymentSwitchMessage,
        },
        AuthStore: { borrowingAmount },
    } = useStore();
    useEffect(() => {
        getPayoffBusinessTime();
    }, [transType]);
    const navigate = useNavigate();
    useEffect(() => {
        if (payOffComplete) {
            setTimeout(() => {
                navigate(0);
            }, 3000);
        }
    }, [payOffComplete]);
    const repayMentTotalAmt = () => {
        if (!payOffMoney) {
            return '0';
        } else {
            return (
                parseInt(payOffMoney || '0') +
                parseInt(repayMentPartInterest || 0)
            );
        }
    };

    let rate = 0;
    const sumVal = stockList.reduce(
        (preVal, curVal) => preVal + curVal.marketVal,
        0
    );
    rate = (sumVal / (borrowingAmount - payOffMoney)) * 100;

    let stockRate = 0;
    const sum = stockList.reduce(
        (preVal, curVal) =>
            preVal +
            (curVal.qty - curVal.repaymentQty) * 1000 * curVal.closePrice,
        0
    );
    const repaymentQtyAmount = stockList.reduce(
        (preVal, curVal) =>
            preVal + curVal.repaymentQty * 1000 * curVal.closePrice,
        0
    );
    stockRate = (sum / (borrowingAmount - repaymentQtyAmount)) * 100;
    return (
        <Page>
            <form
                className="container"
                onSubmit={async e => {
                    e.preventDefault();
                    if (isCash) {
                        await getCashQry(payOffMoney);
                    } else {
                        if (
                            stockList.every(
                                stock => !parseInt(stock.repaymentQty)
                            )
                        ) {
                            updateData('stockApplyModalVisible', false);
                        } else {
                            updateData('stockApplyModalVisible', true);
                        }
                    }
                }}
            >
                <CustomerInfo title="還款申請" />
                <div className="card  wow fadeInDown">
                    {isLoading ? (
                        <Loading isLoading={isLoading} />
                    ) : !payOffComplete ? (
                        <div>
                            <div className="card-body tab-content">
                                <h3 className="title fw-bolder ">
                                    設定還款條件
                                </h3>
                                {/* 還款鎖定 */}
                                <div
                                    className={
                                        repaymentSwitchVisible
                                            ? 'd-none'
                                            : 'message-box position-relative mb-ng2'
                                    }
                                >
                                    <i className="icon_info list-inline-item align-middle "></i>
                                    <div className="d-sm-inline-block h-r3">
                                        {/* 線上還款暫停服務，請洽所屬營業員或分公司協助辦理，造成不便敬請見諒。 */}
                                        {repaymentSwitchMessage}
                                    </div>
                                </div>
                                {repaymentSwitchVisible && (
                                    <div
                                        className={
                                            transInfoVisible
                                                ? 'd-none'
                                                : 'message-box position-relative mb-ng2'
                                        }
                                    >
                                        <i className="icon_info list-inline-item align-middle "></i>
                                        15:00 - 次營業日 9:00，
                                        <div className="d-sm-inline-block">
                                            還款暫停服務
                                        </div>
                                    </div>
                                )}

                                {/* <div className="switch-menu rounded-pill overflow-hidden mw-100 ">
                                    <ul className="nav">
                                        <li
                                            className={`rounded-pill ${
                                                isCash ? 'active' : ''
                                            }`}
                                            onClick={() => {
                                                setIsCash(true);
                                                updateData('payOffMoney', '');
                                            }}
                                        >
                                            <a>現金還款</a>
                                        </li>
                                        <li
                                            className={`rounded-pill ${
                                                isCash ? '' : 'active'
                                            }`}
                                            onClick={() => {
                                                setIsCash(false);
                                                updateData('payOffMoney', '');
                                            }}
                                        >
                                            <a>賣股還款</a>
                                        </li>
                                    </ul>
                                </div>
                                {isCash ? ( */}
                                <IsCash
                                    rate={rate}
                                    repayMentTotalAmt={repayMentTotalAmt()}
                                />
                                {/* ) : (
                                    <IsStock
                                        stockRate={stockRate}
                                        repaymentQtyAmount={repaymentQtyAmount}
                                    />
                                )} */}
                            </div>
                            <Notice>
                                {isCash ? (
                                    <div>
                                        <li>營業日9:00~15:00，可受理還款。</li>
                                        <li>
                                            非使用分戶帳之客戶，請將還款總金額於15:00前自行匯款至指定專戶。
                                        </li>
                                        <li>
                                            使用分戶帳之客戶，申請後將至分戶帳(虛擬帳號)扣除還款總金額，若金額不足視為還款失敗。
                                        </li>
                                    </div>
                                ) : (
                                    <div>
                                        <li className="text-danger ">
                                            申請賣股還款前請自行至交易平台賣出股票，若賣股未成交，則本申請失效。
                                        </li>
                                        <li className="text-danger ">
                                            此為申請償還張數，實際償還張數依您成交張數計算
                                        </li>
                                        <li className="text-danger ">
                                            若您未提出賣股還款申請，賣出股票沖銷順序：現股優先，其次擔保品(賣股還款)。
                                        </li>
                                        <li>營業日9:00~14:40，可受理還款。</li>
                                    </div>
                                )}
                            </Notice>
                        </div>
                    ) : (
                        <Complete
                            feature={'還款'}
                            remindText={'審核成功後，即還款成功。'}
                            loadingFailed={loadingFailed}
                            msg={msg}
                        />
                    )}
                </div>
                <TransFlagModal
                    visibleHandler={transFlagModalVisible}
                    closeModal={closeTransFlagModal}
                    msg={TransMsg}
                />
                <ApplyModal
                    rate={rate}
                    repayMentTotalAmt={repayMentTotalAmt()}
                />
                <StockApplyModal
                    stockRate={stockRate}
                    repaymentQtyAmount={repaymentQtyAmount}
                />
            </form>
        </Page>
    );
};

export default observer(PayOff);
